namespace TabAurous.Master {
    export interface EmployeeDetailsRow {
        DetailId?: number;
        EmployeeId?: number;
        DepartmentId?: number;
        EmployeeName?: string;
    }

    export namespace EmployeeDetailsRow {
        export const idProperty = 'DetailId';
        export const localTextPrefix = 'Master.EmployeeDetails';
        export const lookupKey = 'OMS.EmployeeDetails';

        export function getLookup(): Q.Lookup<EmployeeDetailsRow> {
            return Q.getLookup<EmployeeDetailsRow>('OMS.EmployeeDetails');
        }
        export const deletePermission = 'HR:Employee:Delete';
        export const insertPermission = 'HR:Employee:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:Employee:Edit';

        export declare const enum Fields {
            DetailId = "DetailId",
            EmployeeId = "EmployeeId",
            DepartmentId = "DepartmentId",
            EmployeeName = "EmployeeName"
        }
    }
}
